import * as LD from 'launchdarkly-react-client-sdk';
import { LAUNCH_DARKLY_CLIENT_ID, NODE_ENV } from '@/config/env';
import Session from '@/lib/auth/session';
import StorageService from '@/lib/storage/storage';

// Mock flags for development/test if needed
const allFlagsMock: Record<string, unknown> = {};

let sessionContext: Record<string, unknown> = {};
try {
  const contextSessionResponse = StorageService.getSession('ld-context');
  sessionContext = contextSessionResponse
    ? JSON.parse(contextSessionResponse)
    : {};
} catch {
  sessionContext = {};
}

const deviceId = Session.deviceId();

const baseContext = {
  kind: 'multi',
  user: {
    kind: 'user',
    anonymous: true,
  },
  device: {
    kind: 'device',
    anonymous: true,
    key: deviceId,
    deviceId,
  },
} as const;

const baseOptions = {
  bootstrap: 'localStorage',
} as const;

let client: LD.LDClient | undefined;
if (NODE_ENV === 'test') {
  client = {
    identify: () => Promise.resolve(),
    variation: (name: string, defaultValue: unknown) =>
      allFlagsMock[name] ?? defaultValue,
    allFlags: () => allFlagsMock,
  } as unknown as LD.LDClient;
} else {
  // Ensure we are on client side before initializing if needed,
  // but LD.initialize usually handles it.
  // However, in Next.js SSR, this might run on server.
  // launchdarkly-react-client-sdk is for client side.
  if (typeof window !== 'undefined') {
    client = LD.initialize(
      LAUNCH_DARKLY_CLIENT_ID,
      { ...baseContext, ...sessionContext },
      baseOptions,
    );
  }
}

const LDClient = {
  baseContext,
  baseOptions,
  client: client as LD.LDClient | undefined,
};

export default LDClient;
